import { AuthContext } from "@/provider/AuthProvider";
import { useContext } from "react";

// 使用 AuthContext 的自定义 Hook
export const useAuth = () => useContext(AuthContext);
